import React, { Component } from 'react';
import { ApplicationFormShell } from 'web-ui-components/lib/layout/shells';
import { ContainedHeader } from 'web-ui-components/lib/layout/headers';
import { getCookie, redirectTo, hasStoreCodeBeenSubmittedBefore } from './utils';
import content from './App.content';
import { StatusBanners } from './components/StatusBanners';
import { StorePanel } from './components/StorePanel';

const initialState = {
  hasStoreCodeBeenSetBefore: false,
  existingCookie: {},
  storeCodeSet: false
};
class StoreIdentifier extends Component {
  constructor(props) {
    super(props);
    const {
      parsedParams: { brandParam },
      config: { cookieName }
    } = this.props;

    this.state = {
      ...initialState,
      hasStoreCodeBeenSetBefore: hasStoreCodeBeenSubmittedBefore(getCookie(cookieName), brandParam),
      existingCookie: getCookie(cookieName) || {}
    };
    this.handleRedirectToBrochureware = this.handleRedirectToBrochureware.bind(this);
    this.handleResetStore = this.handleResetStore.bind(this);
  }

  handleResetStore = () => {
    this.setState({ ...initialState });
  };

  handleRedirectToBrochureware = () => {
    const {
      parsedParams: { brandParam },
      config: { redirectionDelay, brochurewareUrls }
    } = this.props;

    this.setState(
      {
        storeCodeSet: true
      },
      () => {
        redirectTo(brochurewareUrls, brandParam, redirectionDelay);
      }
    );
  };

  render() {
    const { storeCodeSet, hasStoreCodeBeenSetBefore } = this.state;
    const { config, parsedParams } = this.props;

    return (
      <ApplicationFormShell header={<ContainedHeader />}>
        <StatusBanners
          hasStoreCodeBeenSetBefore={hasStoreCodeBeenSetBefore}
          storeCodeSet={storeCodeSet}
          content={content}
        />
        <StorePanel
          config={config}
          parsedParams={parsedParams}
          content={content}
          handleRedirectToBrochureware={this.handleRedirectToBrochureware}
          handleResetStore={this.handleResetStore}
        />
      </ApplicationFormShell>
    );
  }
}

export default StoreIdentifier;
